import { IPaginatedList } from 'components/Pagination/constans';
import {
  SearchCombinator,
  SearchConstraintDTO,
  SearchConstraintRootDTO,
  SearchResultsDTO,
  SearchTargetDTO,
  WellIngDTO,
  SeedInfoDTO,
} from 'business/models/Models';
import { getModelArray } from './utils';
import { RuleGroupType } from 'react-querybuilder';
import { cloneDeep } from 'lodash';
import {
  getDropVolHTMl,
  getWellInfoHtml,
} from 'components/commandpanel/IngredientInfo/IngredientInfo';
import { Props as IIngredientWellInfoProps } from 'components/commandpanel/IngredientInfo/IngredientWellInfo';
import { getProteinInfo } from 'components/sidePanel/searchAndFilter/utils';
import { ProteinFormulationData } from 'business/models/Layer';
import { IIngredientProteinInfo } from 'components/commandpanel/IngredientInfo/IngredientProteinInfo';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import {
  EPrecisionType,
  PrecisionFormatter,
} from 'components/plateviewer/render/plate/plateviewer/constants';

export const transformSearchTargets = (
  searchTargets: SearchTargetDTO[],
): SearchTargetDTO[] => {
  return searchTargets.map((i) => i.toJSON());
};

export const transformWellIngredients = (
  wells: WellIngDTO[],
): IPaginatedList<WellIngDTO> => {
  const _wells = wells.map((i) => i.toJSON());
  return transformPagination<WellIngDTO>(_wells, _wells.length);
};

export function transformPagination<T>(
  data: T[],
  total = 0,
  perPage = 1000,
  page = 1,
): IPaginatedList<T> {
  return {
    items: data,
    pagination: { page, perPage, total },
  };
}

export const getSearchConstraintModel = (
  constraints: RuleGroupType,
): SearchConstraintRootDTO => {
  const constraintsModel: SearchConstraintRootDTO = new SearchConstraintRootDTO();
  constraintsModel.rules = getRulesModelArray(cloneDeep(constraints.rules));
  constraintsModel.combinator = constraints.combinator as SearchCombinator;
  constraintsModel.not = constraints.not;
  return constraintsModel;
};

export const getRulesModelArray = (rules) => {
  rules.forEach((r) => {
    if (r.rules) {
      r.rules = getRulesModelArray(r.rules);
    }
  });
  return getModelArray(rules, SearchConstraintDTO);
};

export const transformIIngredientWellInfoProps = (
  wellName,
  isScreenRoute,
  dropVolumes,
  wellLayerIngs,
  wellVolumes,
  formatWithPrecision: PrecisionFormatter,
): IIngredientWellInfoProps => {
  const { wellVolume, wellWaterVolume } = wellVolumes;
  return {
    wellName: wellName,
    isScreenRoute: isScreenRoute,
    dropVol: getDropVolHTMl(dropVolumes),
    wellInfoHTML: getWellInfoHtml(wellLayerIngs, formatWithPrecision),
    wellVolume: wellVolume,
    wellWaterVolume: formatWithPrecision(wellWaterVolume, EPrecisionType.Volume),
  } as IIngredientWellInfoProps;
};

export const transformIIngredientProteinInfo = (
  isScreenRoute: boolean,
  pfInfo,
  dropsData,
  seedInfos: SeedInfoDTO[] = [],
): IIngredientProteinInfo => {
  const proteinInfo = getProteinInfo(pfInfo, dropsData);
  const protein: ProteinFormulationData | null = pfInfo
    ? {
        dropNumber: proteinInfo.dropNumber,
        dropProteinVolume: proteinInfo.dropProteinVolume,
        dropWellVolume: proteinInfo.dropWellVolume,
        name: proteinInfo.name,
        proteinLotId: proteinInfo.proteinLotId,
        volume: proteinInfo.volume,
        datePrepared: proteinInfo.datePrepared,
        storageTemp: proteinInfo.storageTemp,
        pclass: proteinInfo.pclass,
        extCoefficient: proteinInfo.extCoefficient,
        ingredients: pfInfo.pfIng ?? [],
        standardIngredients: pfInfo.pfStIng ?? [],
      }
    : null;
  return {
    isScreenRoute,
    proteins: protein ? [protein] : [],
    seedInfos: seedInfos ?? [],
    well: {},
    dropNumber: dropsData?.dropNumber,
  };
};

export const getSearchResultEntityId = (result: SearchResultsDTO): number => {
  switch (result.type) {
    case ETreeNodeTypes.SynchrotronTripv4:
      return result.synchrotronTripInfo?.id ?? result.treeNodeId;
    case ETreeNodeTypes.FragmentScreen:
      return result.fragmentScreenInfo?.id ?? result.treeNodeId;
    case ETreeNodeTypes.SearchAnalysis:
      return result.searchAnalysisInfo?.id ?? result.treeNodeId;
    default:
      return result.experimentId ? parseInt(result.experimentId, 10) : result.treeNodeId;
  }
};
